import { takeLatest, put, call, select, take } from 'redux-saga/effects';

import { getPaginatedBatchesIfNeeded, downloadAttachmentFile } from './sagas';
import {
  GET_PAGINATED_BATCHES,
  GETTING_PAGINATED_BATCHES_FAILED,
  GET_ATTACHMENT_FILE
} from './actions';
import { actions as UserActions } from '../user';
import { actions as userMessaging } from '../userMessaging';

function* waitForUserReady() {
  const userReady = yield select(store => store.user.ready);
  if (!userReady) {
    yield take(UserActions.LOGIN_READY);
  }
}

function* HandleFailuresSaga() {
  yield takeLatest([GETTING_PAGINATED_BATCHES_FAILED], function*(action) {
    yield put(
      userMessaging.setMessageForFailedAction({
        type: action.type,
        error: action.payload
      })
    );
  });
}

/* APP FLOW - Templates */
function* PaginatedBatchesGetManySaga() {
  yield takeLatest(GET_PAGINATED_BATCHES, function*(action) {
    yield call(waitForUserReady);
    yield call(getPaginatedBatchesIfNeeded, action);
  });
}

function* DownloadAttachmentSaga() {
  yield takeLatest(GET_ATTACHMENT_FILE, function*(action) {
    yield call(waitForUserReady);
    yield call(downloadAttachmentFile, action);
  });
}

export default [
  PaginatedBatchesGetManySaga,
  DownloadAttachmentSaga,
  HandleFailuresSaga
];
